import { FetchContext } from '../fetch-context';
import { Judgement } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const getNominationJudgement: (
  fetchContext: FetchContext,
  nominationId: number,
  userId: number,
  accessToken?: string,
) => Promise<Judgement> = (fetchContext, nominationId, userId, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/nominations/${nominationId}/judges/${userId}/judgement`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<Judgement>(fetchContext.errorStore, response, 'get nomination judgedment'));
